export const EVENTS = {
    eventSelection: "event-selection",
    dateSelection: "date-selection",
    timeSelection: "time-selection"
};

export const SELECTORS = {
    form: "section.simply-book form",
    selectService: ':is(x-dropdown, x-radio-group, x-input[type="hidden"])[name="event"]',
    selectLocation: ':is(x-dropdown, x-input[type="hidden"])[name="location"]',
    selectUnit: ':is(x-dropdown, x-input[type="hidden"])[name="unit"]',
    inputDate: 'x-date-picker[name="date"]',
    inputEndDate: 'x-input[name="endDate"]',
    selectTime: 'x-dropdown[name="time"]',
    inputEndTime: 'x-input[name="endTime"]',
    additional: ":scope fieldset.additional",
    additionalFields: '[name^="additional["],[data-name^="additional["]',
    noItems: "main.account .bookings-manager .no-items",
    accountList: "main.account .bookings-manager .items",
    upcomingList: ".upcoming",
    expiredList: ".expired",
    cancelledList: ".cancelled",
    accountTab: 'main.account [data-tab="bookings"]',
    accountNoItemsTemplate: "#no-booking-items",
    accountItemsTemplate: "#booking-item",
    accountItem: {
        item: ".booking-item",
        dateTime: ":scope .date-time",
        event: ":scope .event",
        btnCancel: ":scope .cancel",
        additional: ":scope .additional",
        location: {
            container: ":scope .location",
            name: ":scope .name",
            address: ":scope .location .address",
            addressItems: {
                address1: ":scope .address1",
                address2: ":scope .address2",
                zip: ":scope .zip",
                city: ":scope .city"
            },
            mapsLink: ":scope .maps-link a"
        },
        booking: {
            code: ":scope .booking .code",
            status: ":scope .booking .status"
        }
    }
};

export const DATE_FORMAT = {
    kebab: "YYYY-MM-DD"
};

export const FIRST_OPTION = {
    value: -1,
    label: `${window.i18n.general.please_choose}&hellip;`
};
